'use strict';

ObjectsDeprecatedGridGridFactory.$inject = ['mx.SolutionBuilderAgent.ObjectsGrid'];
export default function ObjectsDeprecatedGridGridFactory(ObjectsGrid) {
	class ObjectsDeprecatedGrid extends ObjectsGrid {
		constructor() {
			super();
		}

		initProperties() {
			super.initProperties();
			var objectIDs = [],
				objectIDsMode = false,
				addButtonHidden = true,
				externalAddButtonHidden,
				removeButtonHidden = true,
				externalRemoveButtonHidden;

			Object.defineProperties(this, {
				objectIDs: {
					configurable: true,
					get: function () {
						return objectIDs;
					},
				},
				data: {
					configurable: true,
					set: function (newValue) {
						if (Array.isArray(newValue)) {
							objectIDs = newValue;
							this.objectIDsMode = true;
							this.filter = undefined;
							if (this.executor) {
								this.executor.updateRequestOptions({
									objectIDs: newValue,
									returnNoItems: newValue.length === 0,
								});
								this.debouncedLoadItems();
							}
						}
					},
				},
				objectIDsMode: {
					configurable: true,
					get: function () {
						return objectIDsMode;
					},
					set: function (newValue) {
						if (objectIDsMode !== newValue) {
							objectIDsMode = newValue;
							addButtonHidden = !objectIDsMode;
							removeButtonHidden = !objectIDsMode;
						}
					},
				},
				addButtonHidden: {
					configurable: true,
					get: function () {
						return addButtonHidden;
					},
					set: function (newValue) {
						externalAddButtonHidden = Boolean(newValue);
						addButtonHidden = externalAddButtonHidden; // || !objectIDsMode;
					},
				},
				removeButtonHidden: {
					configurable: true,
					get: function () {
						return removeButtonHidden;
					},
					set: function (newValue) {
						externalRemoveButtonHidden = Boolean(newValue);
						removeButtonHidden = externalRemoveButtonHidden || !objectIDsMode;
					},
				},
				parentObject: {
					configurable: true,
					writable: true,
				},
			});
		}

		updateRequest() {
			super.updateRequest();
			if (this.executor && this.objectIDsMode) {
				this.executor.updateRequestOptions({
					returnNoItems: this.objectIDs.length === 0,
				});
			}
		}

		afterEntitiesCreated(entities) {
			if (this.objectIDsMode) {
				return super.afterEntitiesCreated(entities);
			}
		}

		getPresetFields() {
			if (this.parentObject) {
				// legacy support
				return {
					Context: {
						Object: {
							Id: this.parentObject,
						},
					},
				};
			}
		}

		onAddButtonClick() {
			if (this.objectIDsMode) {
				// legacy support
				super.onAddButtonClick();
			} else {
				if (this.allowedTypes && this.allowedTypes.split(',').length === 1) {
					super.onCreateButtonClick({ _type: this.allowedTypes });
				}
			}
		}
	}

	return ObjectsDeprecatedGrid;
}
